import reactComponentLoader from 'scripts/react-component-loader'

import WishlistApp from './index'

reactComponentLoader(WishlistApp, '[data-wishlists]')
